import {
	createAsyncThunk,
	createSlice
} from "@reduxjs/toolkit";

import { loader } from "../../../core/store/loaderSlice";

export const declineVerification = createAsyncThunk(
	"verification/decline",
	async ({ caseId, axiosClient }, { dispatch, rejectWithValue }) => {
		try {
			dispatch(loader({ open: true }));
			const response = await axiosClient.post(
				`verification/decline`,
				{ caseId }
			);
			dispatch(loader({ open: false }));
			return response.data;
		} catch (err) {
			dispatch(loader({ open: false }));
			return rejectWithValue(err.response?.data);
		}
	}
);

const initialState = {
	verificationDeclineResponse: null,
	loading: "idle",
	declineVerificationError: null
};

const verificationDeclineSlice = createSlice({
	name: "verificationDecline",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(declineVerification.pending, (state) => {
			state.loading = "pending";
			state.declineVerificationError = null;
		})
			.addCase(
				declineVerification.fulfilled,
				(state, action) => {
					state.verificationDeclineResponse =
						action.payload;
					state.loading = "idle";
					state.declineVerificationError = null;
				}
			)
			.addCase(
				declineVerification.rejected,
				(state, action) => {
					state.loading = "idle";
					state.verificationDeclineResponse =
						null;
					state.declineVerificationError =
						action.payload;
				}
			);
	}
});

export default verificationDeclineSlice.reducer;
